export const heroStats = [
  { label: '收录作品', value: '12,000+' },
  { label: '每日更新', value: '200+' },
  { label: '在读读者', value: '380万+' },
];

export const features = [
  {
    icon: 'ri-smartphone-line',
    title: '多端同步阅读',
    desc: 'PC端与移动端无缝切换，阅读进度实时同步，随时随地畅享皮皮漫画的精彩内容。',
  },
  {
    icon: 'ri-file-copy-line',
    title: '海量正版资源',
    desc: '收录皮皮漫画韩漫、皮皮漫画日漫、皮皮漫画国漫等超万部优质作品，类型覆盖全面，日更不断档。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速加载体验',
    desc: '采用先进的图片压缩与CDN加速技术，翻页无需等待，沉浸式阅读体验让你停不下来。',
  },
  {
    icon: 'ri-translate',
    title: '专业汉化团队',
    desc: '皮皮漫画拥有资深翻译团队，确保每部韩漫、日漫的翻译质量，原汁原味呈现精彩剧情。',
  },
  {
    icon: 'ri-heart-line',
    title: '个性化收藏',
    desc: '智能推荐算法根据你的阅读偏好推荐漫画，收藏夹与书架功能帮你轻松管理追更列表。',
  },
];

export const faqs = [
  {
    q: '皮皮漫画需要付费吗？',
    a: '皮皮漫画目前所有内容均为免费阅读，无需会员即可畅享全部韩漫、日漫和国漫资源。我们通过广告维持运营，未来如有付费方案会提前公告。',
  },
  {
    q: '皮皮漫画韩漫更新频率如何？',
    a: '皮皮漫画韩漫专区每日更新，热门连载作品每周固定更新2-3话，新作上线后会保持稳定的更新节奏。你可以关注作品页面获取最新话的推送提醒。',
  },
  {
    q: '如何在手机上阅读皮皮漫画？',
    a: '你可以直接在手机浏览器访问皮皮漫画官网，页面已针对移动端深度优化。也可以通过下方APP入口下载皮皮漫画移动客户端，获得更流畅的移动阅读体验。',
  },
  {
    q: '皮皮漫画日漫和国漫有什么区别？',
    a: '皮皮漫画日漫专区以日本漫画为主，涵盖少年热血、少女恋爱、悬疑推理等经典类型；皮皮漫画国漫专区则聚焦国产原创漫画，包含古风仙侠、现代都市、科幻奇幻等特色题材。',
  },
  {
    q: '发现内容问题或想投稿怎么办？',
    a: '如果你发现漫画内容存在错页、翻译问题，或有原创漫画希望投稿合作，可以通过页面底部的联系方式与我们取得联系，我们会在24小时内回复处理。',
  },
];

export const comments = [
  {
    name: '小橘子酱',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20girl%20avatar%20with%20orange%20hair%20and%20warm%20smile%2C%20flat%20illustration%20style%2C%20soft%20pastel%20background%2C%20clean%20simple%20design%2C%20kawaii%20vibe&width=80&height=80&seq=avatar-01&orientation=squarish',
    time: '2小时前',
    comic: '《社内恋爱》',
    text: '皮皮漫画韩漫资源太全了！之前找了好久的那部冷门韩漫居然在这里找到了，画质也很清晰，阅读体验一级棒。',
    likes: 286,
  },
  {
    name: '追更狂魔阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20boy%20avatar%20with%20dark%20hair%20and%20cool%20expression%2C%20flat%20illustration%2C%20minimal%20background%2C%20clean%20design%2C%20modern%20manga%20aesthetic&width=80&height=80&seq=avatar-02&orientation=squarish',
    time: '5小时前',
    comic: '《剑尊归来》',
    text: '每天必刷皮皮漫画！国漫更新速度真的快，《剑尊归来》最新话刚出就有了，翻译质量也很高，良心平台。',
    likes: 157,
  },
  {
    name: '樱花飘落时',
    avatar: 'https://readdy.ai/api/search-image?query=Kawaii%20anime%20girl%20avatar%20with%20pink%20sakura%20theme%2C%20soft%20watercolor%20illustration%20style%2C%20gentle%20pastel%20colors%2C%20sweet%20expression%2C%20minimalist&width=80&height=80&seq=avatar-03&orientation=squarish',
    time: '1天前',
    comic: '《樱花庄的宠物女孩》',
    text: '皮皮漫画日漫的排版看着真舒服，图片没有拉伸变形，放大也很清晰。已经推荐给身边所有喜欢看漫画的朋友了。',
    likes: 423,
  },
  {
    name: '墨染青衣',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20ink%20painting%20style%20anime%20avatar%2C%20elegant%20ancient%20Chinese%20aesthetic%2C%20dark%20long%20hair%2C%20traditional%20hanfu%20inspired%2C%20minimal%20clean%20design&width=80&height=80&seq=avatar-04&orientation=squarish',
    time: '2天前',
    comic: '《斗罗大陆》',
    text: '国漫专区做得太好了，分类清晰找漫画很方便。皮皮漫画国漫类型大全名副其实，古风、都市、科幻应有尽有，爱了爱了！',
    likes: 612,
  },
];

export const rankingList = [
  {
    rank: 1,
    title: '剑尊归来',
    type: '国漫·武侠',
    heat: '980万热度',
    desc: '一代剑尊陨落后重生回到少年时代，带着前世的记忆与剑道感悟，誓要改写命运的轨迹。',
    image: 'https://readdy.ai/api/search-image?query=Martial%20arts%20manhua%20cover%20with%20swordsman%20in%20traditional%20Chinese%20robe%20holding%20glowing%20sword%2C%20dramatic%20lighting%2C%20ancient%20Chinese%20palace%20background%2C%20epic%20composition%2C%20manhua%20art%20style%20with%20vibrant%20colors&width=400&height=560&seq=ranking-01&orientation=portrait',
    tag: '日更',
  },
  {
    rank: 2,
    title: '社内恋爱',
    type: '韩漫·都市',
    heat: '860万热度',
    desc: '高冷女上司与实习生的秘密办公室恋情，甜蜜又刺激的职场浪漫喜剧。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20romance%20webtoon%20cover%20with%20stylish%20office%20couple%20in%20modern%20city%20setting%2C%20soft%20romantic%20lighting%2C%20Korean%20manhwa%20art%20style%2C%20warm%20color%20palette%2C%20clean%20composition&width=400&height=560&seq=ranking-02&orientation=portrait',
    tag: '热门',
  },
  {
    rank: 3,
    title: '暗黑进化',
    type: '日漫·奇幻',
    heat: '750万热度',
    desc: '平凡高中生穿越到异世界获得暗黑之力，从最弱成长为最强的黑暗英雄物语。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20manga%20cover%20with%20hero%20wielding%20dark%20energy%2C%20gothic%20castle%20background%2C%20dramatic%20atmosphere%2C%20Japanese%20manga%20art%20style%2C%20purple%20and%20black%20color%20scheme%2C%20epic%20pose&width=400&height=560&seq=ranking-03&orientation=portrait',
    tag: '新番',
  },
  {
    rank: 4,
    title: '天才宝贝的妈咪',
    type: '韩漫·言情',
    heat: '680万热度',
    desc: '单亲妈妈带着天才萌宝重逢霸道总裁前夫，温馨搞笑又虐心的都市言情大作。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20romance%20webtoon%20cover%20featuring%20beautiful%20mother%20and%20cute%20child%2C%20elegant%20city%20backdrop%2C%20Korean%20manhwa%20art%20style%2C%20warm%20pastel%20colors%2C%20heartwarming%20composition&width=400&height=560&seq=ranking-04&orientation=portrait',
    tag: '飙升',
  },
  {
    rank: 5,
    title: '万古神帝',
    type: '国漫·玄幻',
    heat: '620万热度',
    desc: '少年白起偶得万古神帝传承，从废物逆袭为绝世强者，横扫诸天万界的传奇故事。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20manhua%20cover%20with%20young%20cultivator%20surrounded%20by%20spiritual%20energy%2C%20ancient%20Chinese%20celestial%20palace%2C%20golden%20and%20white%20color%20tones%2C%20epic%20xianxia%20art%20style%2C%20majestic&width=400&height=560&seq=ranking-05&orientation=portrait',
    tag: '日更',
  },
];

export const cardItems = [
  {
    title: '重生之都市修仙',
    subtitle: '国漫·都市玄幻',
    desc: '修仙者重生都市，扮猪吃虎的爽快剧情让你停不下来，画风精美打斗场面燃爆。',
    image: 'https://readdy.ai/api/search-image?query=Urban%20cultivation%20manhua%20scene%20with%20modern%20city%20and%20ancient%20cultivator%20in%20contrast%2C%20Chinese%20manhua%20art%20style%2C%20dramatic%20composition%2C%20vibrant%20energy%20effects%2C%20clean%20background&width=600&height=400&seq=card-01&orientation=landscape',
    tag: '人气爆款',
  },
  {
    title: '我的前世竟是龙',
    subtitle: '日漫·异世界',
    desc: '少年发现自己是上古神龙转世，在异世界展开波澜壮阔的冒险旅程，世界观宏大。',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20isekai%20manga%20scene%20with%20dragon%20silhouette%20and%20fantasy%20adventurer%2C%20magical%20atmosphere%2C%20Japanese%20manga%20art%20style%2C%20warm%20golden%20lighting%2C%20grand%20scale&width=600&height=400&seq=card-02&orientation=landscape',
    tag: '新作上线',
  },
  {
    title: '甜蜜的陷阱',
    subtitle: '韩漫·悬疑爱情',
    desc: '表面甜蜜的恋爱背后隐藏着惊天秘密，反转不断的悬疑爱情故事让你欲罢不能。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20romantic%20thriller%20webtoon%20scene%20with%20couple%20in%20moody%20lighting%2C%20mysterious%20urban%20night%20setting%2C%20Korean%20manhwa%20art%20style%2C%20suspenseful%20atmosphere%2C%20contrasting%20warm%20and%20cool%20tones&width=600&height=400&seq=card-03&orientation=landscape',
    tag: '悬疑佳作',
  },
  {
    title: '绝世神医',
    subtitle: '国漫·古风医道',
    desc: '天才神医穿越古代，以超凡医术济世救人，权谋斗争与医道传承交织的精彩国漫。',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20medical%20manhua%20scene%20with%20physician%20in%20traditional%20robe%2C%20herbal%20medicine%20elements%2C%20elegant%20ancient%20Chinese%20architecture%2C%20manhua%20art%20style%2C%20warm%20earthy%20tones&width=600&height=400&seq=card-04&orientation=landscape',
    tag: '口碑推荐',
  },
  {
    title: '机甲战纪',
    subtitle: '日漫·科幻机甲',
    desc: '近未来世界，少年驾驶员与智能机甲并肩作战，热血机甲对战与深刻人性刻画并存。',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20mecha%20manga%20scene%20with%20giant%20robot%20in%20futuristic%20city%2C%20sci-fi%20atmosphere%2C%20Japanese%20manga%20art%20style%2C%20cool%20metallic%20colors%2C%20dynamic%20action%20pose&width=600&height=400&seq=card-05&orientation=landscape',
    tag: '燃系必看',
  },
];

export const topicTags = [
  { name: '韩漫推荐', count: '2.3万讨论', icon: 'ri-fire-line', hot: true },
  { name: '日漫新番', count: '1.8万讨论', icon: 'ri-sun-line', hot: true },
  { name: '国漫崛起', count: '3.1万讨论', icon: 'ri-rocket-line', hot: true },
  { name: '恋爱甜漫', count: '1.5万讨论', icon: 'ri-heart-line', hot: false },
  { name: '热血战斗', count: '1.2万讨论', icon: 'ri-sword-line', hot: false },
  { name: '悬疑推理', count: '9.8千讨论', icon: 'ri-search-eye-line', hot: false },
  { name: '穿越重生', count: '2.7万讨论', icon: 'ri-loop-right-line', hot: true },
  { name: '古风仙侠', count: '1.6万讨论', icon: 'ri-moon-line', hot: false },
  { name: '搞笑日常', count: '8.5千讨论', icon: 'ri-emotion-laugh-line', hot: false },
  { name: '异能超能', count: '7.2千讨论', icon: 'ri-flashlight-line', hot: false },
];

export const carouselItems = [
  {
    title: '2024韩漫年度精选',
    desc: '盘点今年最值得看的50部皮皮漫画韩漫佳作，从甜蜜恋爱到悬疑惊悚一网打尽。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20collage%20featuring%20various%20romance%20and%20drama%20characters%2C%20colorful%20vibrant%20Korean%20manhwa%20art%20style%2C%20festive%20banner%20composition%2C%20warm%20and%20energetic%20atmosphere%2C%20clean%20design&width=800&height=450&seq=carousel-01&orientation=landscape',
    tag: '年度盘点',
  },
  {
    title: '国漫武侠宇宙专题',
    desc: '从《剑尊归来》到《万古神帝》，皮皮漫画国漫武侠巅峰对决，谁才是你心中的第一剑客？',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20manhua%20battle%20scene%20with%20multiple%20swordsmen%20in%20epic%20confrontation%2C%20ancient%20Chinese%20mountain%20landscape%2C%20manhua%20art%20style%2C%20golden%20and%20red%20color%20scheme%2C%20grand%20cinematic&width=800&height=450&seq=carousel-02&orientation=landscape',
    tag: '武侠盛宴',
  },
  {
    title: '日漫异世界入坑指南',
    desc: '异世界题材眼花缭乱不知道怎么选？这份皮皮漫画日漫异世界清单帮你快速找到本命作品。',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20isekai%20fantasy%20manga%20collage%20with%20diverse%20adventurers%20and%20magical%20creatures%2C%20colorful%20Japanese%20manga%20art%20style%2C%20fantasy%20world%20background%2C%20exciting%20adventure%20vibe&width=800&height=450&seq=carousel-03&orientation=landscape',
    tag: '入坑指南',
  },
  {
    title: '甜到牙疼的恋爱漫合集',
    desc: '皮皮漫画精选高糖恋爱漫画，韩漫的细腻、日漫的纯情、国漫的浪漫，一次满足你的少女心。',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20manga%20collage%20with%20various%20couples%20in%20sweet%20moments%2C%20soft%20pastel%20color%20palette%2C%20shoujo%20manga%20art%20style%2C%20cherry%20blossom%20and%20heart%20motifs%2C%20dreamy%20atmosphere&width=800&height=450&seq=carousel-04&orientation=landscape',
    tag: '甜蜜特辑',
  },
  {
    title: '暑期必追热血漫推荐',
    desc: '暑假不知道看什么？这份皮皮漫画热血漫片单陪你燃爆整个夏天，从日漫经典到国漫新秀全覆盖。',
    image: 'https://readdy.ai/api/search-image?query=Action%20shonen%20manga%20collage%20with%20dynamic%20battle%20scenes%20and%20determined%20heroes%2C%20Japanese%20manga%20art%20style%2C%20fiery%20orange%20and%20red%20color%20scheme%2C%20energetic%20summer%20vibe&width=800&height=450&seq=carousel-05&orientation=landscape',
    tag: '暑期特供',
  },
  {
    title: '悬疑烧脑漫通关挑战',
    desc: '皮皮漫画悬疑推理专题，精选高智商对决与反转神作，看看你能猜到第几话的真凶？',
    image: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20manga%20collage%20with%20detective%20silhouettes%20and%20clue%20elements%2C%20dark%20moody%20color%20palette%2C%20suspenseful%20manga%20art%20style%2C%20noir%20atmosphere%2C%20mysterious%20composition&width=800&height=450&seq=carousel-06&orientation=landscape',
    tag: '烧脑挑战',
  },
];

export const indexItems = [
  { title: '少年热血', count: '856部', icon: 'ri-fire-line', color: 'accent' },
  { title: '少女恋爱', count: '742部', icon: 'ri-heart-line', color: 'primary' },
  { title: '古风仙侠', count: '518部', icon: 'ri-moon-line', color: 'secondary' },
  { title: '都市言情', count: '623部', icon: 'ri-building-line', color: 'primary' },
  { title: '悬疑推理', count: '389部', icon: 'ri-search-eye-line', color: 'accent' },
  { title: '科幻未来', count: '276部', icon: 'ri-rocket-line', color: 'secondary' },
  { title: '搞笑日常', count: '445部', icon: 'ri-emotion-laugh-line', color: 'primary' },
  { title: '恐怖灵异', count: '198部', icon: 'ri-ghost-line', color: 'accent' },
  { title: '运动竞技', count: '167部', icon: 'ri-basketball-line', color: 'secondary' },
];

export const updateItems = [
  {
    date: '2024-07-28',
    title: '《剑尊归来》第183话已更新',
    desc: '剑尊在九幽秘境中遭遇上古强敌，一场惊天大战即将开启。最新章节画质提升，打斗分镜流畅度大幅优化。',
    tag: '国漫更新',
  },
  {
    date: '2024-07-28',
    title: '《社内恋爱》第96话甜蜜上线',
    desc: '男女主角终于表白！皮皮漫画韩漫专区本日最甜更新，评论区已被祝褔刷屏。',
    tag: '韩漫更新',
  },
  {
    date: '2024-07-27',
    title: '新作《魔法学院生存指南》正式上线',
    desc: '皮皮漫画日漫专区迎来全新连载，魔法校园题材融合生存挑战，首日即获9.6分高评价。',
    tag: '日漫新作',
  },
  {
    date: '2024-07-27',
    title: '《万古神帝》突破1000话里程碑',
    desc: '皮皮漫画国漫玄幻巨作达成千话成就，官方推出纪念专题回顾白起的修炼之路。',
    tag: '国漫里程碑',
  },
  {
    date: '2024-07-26',
    title: '暑期阅读活动「漫无止境」火热进行中',
    desc: '参与皮皮漫画暑期阅读挑战，解锁限定头像框和专属书单推荐，阅读时长Top100还有实物周边奖励。',
    tag: '站内活动',
  },
  {
    date: '2024-07-26',
    title: '《暗黑进化》动画化决定',
    desc: '皮皮漫画日漫人气作品宣布动画化！预计明年春季开播，站内原著阅读量已暴涨300%。',
    tag: '重磅新闻',
  },
  {
    date: '2024-07-25',
    title: '阅读器功能升级：夜间模式与横屏适配',
    desc: '皮皮漫画全平台阅读器迎来重大更新，新增护眼夜间模式和横屏双页阅读模式，体验再升级。',
    tag: '功能更新',
  },
];

export const mediaItems = [
  {
    title: '皮皮漫画韩漫推荐：这5部神作你绝对不能错过',
    desc: '精选五部口碑爆表的皮皮漫画韩漫，从剧情到画风全方位解析，帮你快速找到下一部入坑作品。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20thumbnail%20with%20multiple%20popular%20characters%20collage%2C%20colorful%20vibrant%20Korean%20manhwa%20style%2C%20video%20player%20overlay%20design%2C%20YouTube%20thumbnail%20aesthetic%2C%20clean%20composition&width=600&height=340&seq=media-01&orientation=landscape',
    duration: '12:36',
    views: '28.6万',
  },
  {
    title: '国漫崛起！盘点2024上半年必看国漫作品',
    desc: '皮皮漫画国漫专区上半年数据大盘点，哪些作品最受欢迎？哪些新人作者值得关注？',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20popular%20works%20collage%20thumbnail%2C%20bright%20energetic%20Chinese%20manhua%20art%20style%2C%20ranking%20visual%20design%2C%20video%20player%20overlay%2C%202024%20year%20theme&width=600&height=340&seq=media-02&orientation=landscape',
    duration: '18:22',
    views: '42.1万',
  },
  {
    title: '从零开始的漫画阅读指南：皮皮漫画使用全攻略',
    desc: '新用户必看！手把手教你如何在皮皮漫画找到喜欢的作品、使用书架功能和调整阅读设置。',
    image: 'https://readdy.ai/api/search-image?query=Tutorial%20style%20comic%20reading%20app%20showcase%20thumbnail%2C%20clean%20modern%20design%2C%20friendly%20illustration%20style%2C%20warm%20colors%2C%20guide%20aesthetic%2C%20step%20by%20step%20feel&width=600&height=340&seq=media-03&orientation=landscape',
    duration: '08:45',
    views: '15.3万',
  },
];